import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

// Leaflet
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { LeafletMarkerClusterModule } from "@asymmetrik/ngx-leaflet-markercluster";

// Material
import { MatCardModule } from "@angular/material/card";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatChipsModule } from "@angular/material/chips";

// Translate
import { TranslateModule } from "@ngx-translate/core";

// Components
import { MiniMapComponent } from "./mini-map/mini-map.component";
import { MapDetailsDialogComponent } from "../dialogs/map-details-dialog/map-details-dialog.component";

/**
 * Módulo compartido para componentes de mapas
 * Exporta MiniMapComponent para uso en otros módulos
 */
@NgModule({
	declarations: [MiniMapComponent, MapDetailsDialogComponent],
	imports: [
		CommonModule,
		FormsModule,
		LeafletModule,
		LeafletMarkerClusterModule,
		MatCardModule,
		MatProgressSpinnerModule,
		MatButtonModule,
		MatIconModule,
		MatChipsModule,
		TranslateModule,
	],
	exports: [MiniMapComponent, MapDetailsDialogComponent],
})
export class SharedMapsModule {}
